'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var siteUrl = window.PAGE_CONFIG.BASE_URL + '/city_geo/find?type=city&province=%E5%B9%BF%E4%B8%9C%E7%9C%81';
setTimeout(function () {
  $.ajax({
    url: siteUrl
  }).then(function (data) {
    var tagObject = data;
    $.each(tagObject, function (i) {
      var latlngssArr = $.parseJSON(tagObject[i].bound);
      latlngssArr.map(function (item) {
        var latlngs = item.map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              a = _ref2[0],
              b = _ref2[1];

          return [b, a];
        });
        L.polygon(latlngs, {
          color: 'red'
        }).addTo(map);
      });
    });
  });
}, 1000);


//////////////////
// WEBPACK FOOTER
// ./js/drawingOverlay.js
// module id = 19
// module chunks = 0